// extracted by mini-css-extract-plugin
module.exports = {"droppedBox":"Dropdowner_droppedBox__3eMR-","dropdownerContainer":"Dropdowner_dropdownerContainer__VUtay"};